import { Group, Text } from "@mantine/core";
import packageJson from "../../../package.json";

export default function AppFooter() {
  return (
    <Group h="100%" px="md" justify="center">
      <Text size="xs" c="dimmed">
        v{packageJson.version}
      </Text>
    </Group>
  );
}
